import React from 'react';
import { Modal, Button, Table } from 'react-bootstrap';

const ModalConfirmacaoEnvio = ({ show, registros, onConfirmar, onCancelar, enviando }) => (
  <Modal show={show} onHide={onCancelar} size="lg" backdrop="static">
    <Modal.Header closeButton>
      <Modal.Title>Confirmar Envio de SMS</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>
        Você está prestes a enviar <strong>{registros.length}</strong> SMS. Confira os destinatários:
      </p>
      <div style={{ maxHeight: 350, overflowY: 'auto' }}>
        <Table striped bordered size="sm">
          <thead>
            <tr>
              <th>Cliente</th>
              <th>Celular</th>
              <th>Mensagem (prévia)</th>
            </tr>
          </thead>
          <tbody>
            {registros.map((r, idx) => (
              <tr key={`${r.codigo_titulo || r.cpf}-${idx}`}>
                <td>{r.nome}</td>
                <td>{r.celular}</td>
                <td>
                  {r.mensagem
                    ? r.mensagem.length > 60
                      ? `${r.mensagem.substring(0, 60)}...`
                      : r.mensagem
                    : '-'}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <span className="mr-auto text-muted">Total: {registros.length} SMS</span>
      <Button variant="secondary" onClick={onCancelar} disabled={enviando}>
        Cancelar
      </Button>
      <Button variant="primary" onClick={onConfirmar} disabled={enviando}>
        {enviando ? 'Enviando...' : 'Confirmar'}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default ModalConfirmacaoEnvio;
